import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
          textAlign: 'center',
          fontFamily: 'Georgia, serif',
        }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>📖</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Oups, une page s'est envolée !</h1>
          <p style={{ fontSize: 14, color: '#888', lineHeight: 1.6, maxWidth: 320, marginBottom: 24 }}>
            Une erreur inattendue s'est produite. Pas de panique, tes données sont en sécurité.
          </p>
          <button
            onClick={() => window.location.href = '/swipe'}
            style={{
              padding: '12px 28px',
              borderRadius: 12,
              border: 'none',
              background: 'linear-gradient(135deg, #c8956c, #d4a574)',
              color: 'white',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Retour à l'accueil
          </button>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); }}
            style={{
              marginTop: 10,
              padding: '8px 20px',
              borderRadius: 10,
              border: 'none',
              background: 'none',
              color: '#888',
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Réessayer
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}